import { TestEventType } from "~/features/testingTools/testingTools.types";

import { warehouseApi } from "./warehouseApi";

export type StartPtlTestBody = {
  displaysToActivate: number[];
  displaysToClean: number[];
  gridId: string;
  workstationId: string;
};
export type SimulatePTLButtonPressBody = {
  deviceId: number;
  text: string;
  pickId: string;
  gridId: string;
};

// By extending GenericObject, EventData can carry any additional key/value pairs
// Needed by future features or integrations without altering the interface
export interface EventData extends GenericObject {
  DeviceId?: Guid;
}

export type TestEventDto = {
  eventType: TestEventType;
  eventId: Guid;
  eventTimestamp: Date;
  data: EventData;
  clientId: Guid;
  workstationId: Guid;
  fulfillmentCenterId: Guid;
  userId: Guid;
};

export type InsertTestEventDto = {
  eventTimestamp: Date;
  eventType: TestEventType;
  data: EventData;
  workstationId: Guid;
};

export type GetPortStatusForBinCircus = {
  binCircusRunning: boolean;
  portId: number;
  message: string;
};

export const testingToolsApi = warehouseApi.injectEndpoints({
  endpoints: (build) => ({
    startPtlTest: build.mutation<null, StartPtlTestBody>({
      query: (body) => ({
        url: "/ptl/start-ptl-test",
        method: "POST",
        body
      })
    }),
    simulatePressPTLButton: build.mutation<null, SimulatePTLButtonPressBody>({
      query: ({ gridId, ...body }) => ({
        url: `/ptl/simulate-press-button`,
        method: "POST",
        body,
        params: {
          gridId
        }
      })
    }),
    getInternalTestEventFeed: build.query<
      TestEventDto[],
      { selectedFulfillmentCenterId: Guid }
    >({
      query: ({ selectedFulfillmentCenterId }) => {
        return {
          url: "/internal-test-events",
          method: "GET",
          params: {
            fulfillmentCenterId: selectedFulfillmentCenterId
          }
        };
      },
      providesTags: ["test events"]
    }),
    postInternalTestEvent: build.mutation<
      null,
      { eventData: InsertTestEventDto }
    >({
      query: ({ eventData }) => ({
        url: "/internal-test-events",
        method: "POST",
        body: eventData
      })
    }),
    startBinCircus: build.mutation<
      string,
      {
        portId: number;
        gridId: string;
        taskGroupSize: number;
      }
    >({
      query: ({ portId, gridId, taskGroupSize }) => ({
        url: `/bin-circus/autostore-grid/${gridId}/port/${portId}/open-port`,
        method: "POST",
        body: { taskGroupSize }
      }),
      invalidatesTags: (_result, _error, { portId, gridId }) => [
        { type: "port status for bin circus", id: `${gridId}-${portId}` }
      ]
    }),
    stopBinCircus: build.mutation<
      string,
      {
        portId: number;
        gridId: string;
      }
    >({
      query: ({ portId, gridId }) => ({
        url: `/bin-circus/autostore-grid/${gridId}/port/${portId}/close-port`,
        method: "POST"
      }),
      invalidatesTags: (_result, _error, { portId, gridId }) => [
        { type: "port status for bin circus", id: `${gridId}-${portId}` }
      ]
    }),
    getPortStatusForBinCircus: build.query<
      GetPortStatusForBinCircus,
      { portId: number; gridId: string }
    >({
      query: ({ portId, gridId }) => ({
        url: `/bin-circus/autostore-grid/${gridId}/port/${portId}`,
        method: "GET"
      }),
      providesTags: (_result, _error, { portId, gridId }) => [
        { type: "port status for bin circus", id: `${gridId}-${portId}` }
      ]
    })
  })
});
